import { Box, Button, MenuItem } from "@material-ui/core"
import { useEffect } from "react"
import type { ReactElement } from "react"
import { useForm } from "react-hook-form"

import { ChapterZone } from "../../../models"
import type { Chapter, Licence } from "../../../redux"
import { TextInputField } from "../../atoms"
import { FormValidationErrors, LicenceField } from "../../molecules"

import "./chapter-manager-form.styles.scss"
import { useTranslation } from "react-i18next"

export interface IChapterManagerFormProps {
  chapter: Chapter
  licences: Licence[]
  saveChapter: (chapter: Chapter) => void
}

export function ChapterManagerForm(props: IChapterManagerFormProps): ReactElement {
  const { chapter, licences, saveChapter } = props
  const {
    control,
    formState: { errors, submitCount },
    reset,
    handleSubmit
  } = useForm<Chapter>({
    defaultValues: chapter
  })
  const { t } = useTranslation("contentManager")
  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO in a later PR
  useEffect(() => {
    reset(chapter)
  }, [chapter])

  function onSubmit(data: Chapter): void {
    saveChapter(data)
  }

  return (
    <form className="chapter-manager-form" onSubmit={handleSubmit(onSubmit)}>
      <Box className="double-field">
        <TextInputField
          name="name"
          control={control}
          required={t("chapters.formFields.requiredChapter")}
          label={t("chapters.formFields.chapterTitle")}
        />
        <LicenceField
          name="licenceIds"
          control={control}
          required={t("commonFormfields.requiredLicence")}
          label={t("commonFormfields.licences")}
          className="licence-field"
          licences={licences}
        />
      </Box>

      <Box className="double-field">
        <TextInputField
          name="order"
          control={control}
          required={t("commonFormfields.requiredOrderTableContents")}
          label={t("commonFormfields.orderTableContents")}
        />
        <TextInputField
          name="zone"
          control={control}
          required={t("chapters.formFields.requiredZone")}
          label={t("chapters.formFields.zonePage")}
          select
          defaultValue={ChapterZone.TOP}
        >
          <MenuItem value={ChapterZone.TOP}>{t("chapters.formFields.top")}</MenuItem>
          <MenuItem value={ChapterZone.BOTTOM}>{t("chapters.formFields.bottom")}</MenuItem>
        </TextInputField>
      </Box>

      <TextInputField
        name="thumbnailUrl"
        control={control}
        required={t("chapters.formFields.requiredThumbnail")}
        label={t("chapters.formFields.assetIdForThumbnail")}
      />

      <Button type="submit" variant="contained" color="primary">
        {t("save")}
      </Button>

      <FormValidationErrors errors={errors} submitCount={submitCount} />
    </form>
  )
}
